import { SiteHeader } from '@/components/site-header'
import { SiteFooter } from '@/components/site-footer'
import { PageHeader } from '@/components/page-header'

interface StaticLayoutProps {
  title: string
  description?: string
  children: React.ReactNode
}

export function StaticLayout({ title, description, children }: StaticLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHeader title={title} description={description} />
        <article className="container max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16 prose prose-slate dark:prose-invert">
          {children}
        </article>
      </main>
      <SiteFooter />
    </div>
  )
}
